import {RECUPERAR_VALOR_PRECO} from '../../actions/types'

const initialState = []

export default function reducerRecuperarValorPrecoIdaVolta(state = initialState, action) {
  switch (action.type) {
    case RECUPERAR_VALOR_PRECO: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
